import type { WidgetId } from '../../selfOwnedWidget';
import type { WidgetHostContainer } from '../Container';
import { computed, createModel } from '@preact/signals-react';
import type { Model, ModelConstructor, ReadonlySignal } from '@preact/signals-react';
import type { EventBus } from 'src/types/EventBus/EventBus';
import { EventBusBuilder } from 'src/types/EventBus/EventBus';
import type { ChannelChangeEvent, ChannelSignal, ResetChannelDataEvent } from 'src/types/EventBus/index';

export type ContainerChannelSliceEventBus = EventBus<ChannelSignal, ChannelChangeEvent & ResetChannelDataEvent>;

interface ContainerChannelSliceInit {
    container: WidgetHostContainer;
    tabId: WidgetId;
}

export interface ContainerChannelSliceModel {
    readonly channel: ReadonlySignal<string | null>;
    readonly eventBus: ContainerChannelSliceEventBus;
}

export const ContainerChannelSlice: ModelConstructor<ContainerChannelSliceModel, [ContainerChannelSliceInit]> =
    createModel<ContainerChannelSliceModel, [ContainerChannelSliceInit]>((init: ContainerChannelSliceInit) => {
        const channel: ReadonlySignal<string | null> = computed(() => {
            const tab = init.container.tabs.value.find((t) => t.id === init.tabId);
            const channelId = (tab?.widget as { channelId?: string | null } | undefined)?.channelId;
            return channelId ?? null;
        });

        const eventBus: ContainerChannelSliceEventBus = EventBusBuilder.create()
            .addSignal('widget::channel', () => channel)
            .addEvent('widget::channelChange', ({ channel: nextChannel }) => {
                init.container.setTabChannel(init.tabId, nextChannel);
            })
            .addEvent('widget::resetChannelData', () => {
                init.container.resetTabChannelData(init.tabId);
            })
            .build();

        return { channel, eventBus };
    });

export type ContainerChannelSlice = Model<ContainerChannelSliceModel>;
